/**
 * TODO: 应该放到 SDK ?
 */
export enum JoinMeetingError {
  wrongPassword = '13402', // 进会密码错误
  onlyCorp = '13416', // 仅企业内部成员可以入会
  banList = '9095', // 黑名单列表
  webInar = '22316', // 不能加入webinar
  important = '13421', // 重保后台限制
  timeout = 'sdk-408', // SDK自定义的枚举
}
